export const TrashIcon = () => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_779_4856)">
        <path
          d="M4.5 1.5H7.5M1.5 3H10.5M9.5 3L9.14936 8.25964C9.09675 9.04877 9.07044 9.44333 8.90001 9.7425C8.74996 10.0059 8.52362 10.2176 8.25083 10.3498C7.94098 10.5 7.54555 10.5 6.75467 10.5H5.24533C4.45445 10.5 4.05902 10.5 3.74917 10.3498C3.47638 10.2176 3.25004 10.0059 3.09999 9.7425C2.92956 9.44333 2.90325 9.04877 2.85064 8.25965L2.5 3M5 5.25V7.75M7 5.25V7.75"
          stroke="#9A0000"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_779_4856">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
